import { useState, useEffect } from "react";
import "../housestyle.css";
import "./Ranks.css";
import * as Icons from "../Icons/Icons";
import api from "../API/Api";
import PageHero from "../components/PageHero";

const HERO_VIDEO = 'https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/background_vids/vid_3.mp4';

// Maps rank name (lowercase) from DB → local icon import
const RANK_ICONS = {
  zombie: Icons.zombie,
  skeleton: Icons.skeleton,
  creeper: Icons.creeper,
  blaze: Icons.blaze,
  breeze: Icons.breeze,
  phantom: Icons.phantom,
  warden: Icons.warden,
};

function calcDiscounted(price, percent) {
  return (price * (1 - percent / 100)).toFixed(2);
}

function BuyModal({ rank, saleCode, onClose }) {
  const [copied, setCopied] = useState(false);
  const pct = rank.discount_percent;
  const discountedPrice = pct ? calcDiscounted(rank.price, pct) : null;
  const showCode = saleCode && pct;

  function handleBackdrop(e) {
    if (e.target === e.currentTarget) onClose();
  }

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  function copy() {
    navigator.clipboard.writeText(saleCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  const icon = RANK_ICONS[rank.name.toLowerCase()];

  return (
    <div className="modal-backdrop" onClick={handleBackdrop}>
      <div
        className="modal-box"
        style={{ borderTop: `3px solid ${rank.color}` }}
      >
        <button className="modal-close" onClick={onClose} aria-label="Close">
          ✕
        </button>

        <div className="modal-header">
          <div
            className="modal-icon-wrap"
            style={{ filter: `drop-shadow(0 0 14px ${rank.color})` }}
          >
            {icon && <img src={icon} alt={rank.name} className="modal-icon" />}
          </div>
          <div>
            <div className="modal-rank-name" style={{ color: rank.color }}>
              {rank.name.charAt(0).toUpperCase() + rank.name.slice(1)}
            </div>
            <div className="modal-price-row">
              {discountedPrice ? (
                <>
                  <span className="modal-price-old">
                    SOON!
                  </span>
                  {/* <span className="modal-price-old">
                    €{rank.price.toFixed(2)}
                  </span>
                  <span className="modal-price-new">€{discountedPrice}</span>
                  <span
                    className="modal-badge"
                    style={{ background: rank.color }}
                  >
                    -{pct}%
                  </span> */}
                </>
              ) : (
                // <span className="modal-price-new">
                //   €{rank.price.toFixed(2)}
                // </span>
                <span className="modal-price-new">SOON!</span>
              )}
            </div>
          </div>
        </div>

        <div className="modal-perks-label">Included perks</div>
        <div className="modal-perks">
          {rank.perks.map((p) => (
            <div key={p} className="modal-perk">
              <span className="modal-perk-check" style={{ color: rank.color }}>
                ✓
              </span>
              {p}
            </div>
          ))}
        </div>

        {showCode && (
          <div className="modal-code-row">
            <span className="modal-code-label">Use code at checkout:</span>
            <button className="modal-code-btn" onClick={copy}>
              <span className="modal-code-text">{saleCode}</span>
              <span className="modal-code-copy">
                {copied ? "Copied!" : "Copy"}
              </span>
            </button>
          </div>
        )}

        <div className="modal-actions">
          <button className="btn modal-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <a
            // href={rank.tebex_url}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary modal-buy-btn"
            style={{ background: rank.color }}
          >
            SOON
          </a>
        </div>

        <p className="modal-disclaimer">
          Ranks are permanent and carry over between seasons. No refunds after
          rank has been applied.
        </p>
      </div>
    </div>
  );
}

export default function Ranks() {
  const [ranks, setRanks] = useState([]);
  const [sale, setSale] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedRank, setSelectedRank] = useState(null);

  useEffect(() => {
    api("getranks").then((res) => {
      if (res.isSuccess && res.data) {
        setRanks(res.data.ranks ?? []);
        setSale(res.data.sale ?? null);
      }
      setLoading(false);
    });
  }, []);

  return (
    <>
      <PageHero
        video={HERO_VIDEO}
        eyebrow="Support the Server"
        title="Ranks & "
        em="Store"
        subtitle="Purchase a rank to support SimpleMC and unlock exclusive perks, cosmetics and bonuses in-game."
        height={"300px"}
      >
      </PageHero>

      <div className="container section">
        <div className="section-label">
          <span className="sl-text">All Ranks</span>
        </div>

        {loading ? (
          <div className="ranks-loading">Loading ranks…</div>
        ) : (
          <div className="ranks-grid">
            {ranks.map((rank, i) => {
              const pct = rank.discount_percent;
              const discountedPrice = pct
                ? calcDiscounted(rank.price, pct)
                : null;
              const icon = RANK_ICONS[rank.name.toLowerCase()];
              const displayName =
                rank.name.charAt(0).toUpperCase() + rank.name.slice(1);

              return (
                <div
                  key={rank.id}
                  className="rank-card card fade-up"
                  style={{ animationDelay: `${i * 0.06}s` }}
                >
                  <div
                    className="rank-card-top"
                    style={{ borderColor: rank.color + "55" }}
                  >
                    <div
                      className="rank-card-top-glow"
                      style={{ background: rank.color }}
                    />
                    <div
                      className="rank-icon-wrap"
                      style={{ filter: `drop-shadow(0 0 15px ${rank.color})` }}
                    >
                      {icon && (
                        <img
                          src={icon}
                          alt={displayName}
                          className="rank-icon"
                        />
                      )}
                    </div>
                    <div>
                      <div className="rank-name" style={{ color: rank.color }}>
                        {displayName}
                      </div>
                      {discountedPrice ? (
                        // <div className="rank-price-group">
                        //   <span className="rank-price-old">
                        //     €{rank.price.toFixed(2)}
                        //   </span>
                        //   <span className="rank-price">€{discountedPrice}</span>
                        //   <span
                        //     className="rank-discount-badge"
                        //     style={{ background: rank.color }}
                        //   >
                        //     -{pct}%
                        //   </span>
                        // </div>
                          <div className="rank-price-group">
                            <span className="rank-price">
                              SOON!
                            </span>
                          </div>
                      ) : (
                        // <div className="rank-price">
                        //   €{rank.price.toFixed(2)}
                        // </div>
                        <div className="rank-price">
                          SOON!
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="rank-perks">
                    {rank.perks.map((p) => (
                      <div key={p} className="rank-perk">
                        <span
                          className="rank-perk-check"
                          style={{ color: rank.color }}
                        >
                          ✓
                        </span>
                        {p}
                      </div>
                    ))}
                  </div>

                  <button
                    className="btn btn-primary rank-buy-btn"
                    style={{ background: rank.color }}
                    onClick={() => setSelectedRank(rank)}
                  >
                    Buy {displayName}
                  </button>
                </div>
              );
            })}
          </div>
        )}

        <div className="ranks-disclaimer card-raised">
          <img
            src={Icons.info}
            alt="Disclaimer"
            style={{ width: "30px" }}
            className="ranks-disclaimer-icon"
          />
          <p>
            Ranks are permanent and carry over between seasons unless stated
            otherwise. All purchases support server costs. By purchasing you
            agree to our terms — no refunds after the rank has been applied.
          </p>
        </div>
      </div>

      {selectedRank && (
        <BuyModal
          rank={selectedRank}
          saleCode={sale?.active ? sale.code : null}
          onClose={() => setSelectedRank(null)}
        />
      )}
    </>
  );
}
